var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('dialogBox', [_c('rules', {
    attrs: {
      "rule": ""
    },
    on: {
      "listenToChildEvent": _vm.noticeFatherCloseLayer
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };